import { render, staticRenderFns } from "./CompanyInformation.vue?vue&type=template&id=289de5c9"
import script from "./CompanyInformation.vue?vue&type=script&lang=ts"
export * from "./CompanyInformation.vue?vue&type=script&lang=ts"
import style0 from "./CompanyInformation.vue?vue&type=style&index=0&id=289de5c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports